import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=510d8fcb&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510d8fcb')) {
      api.createRecord('510d8fcb', component.options)
    } else {
      api.reload('510d8fcb', component.options)
    }
    module.hot.accept("./Article.vue?vue&type=template&id=510d8fcb&", function () {
      api.rerender('510d8fcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Article/Article.vue"
export default component.exports